var scope_0 = require('/zeit/174ff4d1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/zeit/174ff4d1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/64663b9ac769ba6c2f13d5b2e4cc297e.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    